import React from 'react'

import { Timeline, TimelineConnector, TimelineContent, TimelineItem, TimelineSeparator } from '@mui/lab'
import { Box, Card, CardContent, Skeleton } from '@mui/material'

import './LiveEventEvolutionTimeline.scss'

export const LiveEventEvolutionTimelineSkeleton: React.FC = () => {
  return (
    <Timeline position="alternate" className="LiveEventEvolutionTimeline LiveEventEvolutionTimelineSkeleton">
      {/* PRESENT DOT SKELETON */}
      <TimelineItem>
        <TimelineSeparator className="LiveEventEvolutionTimelineSeparator">
          <Skeleton variant="rounded" width={100} height={24} sx={{ margin: '8px 0px 8px 0px', borderRadius: '25px' }} />
          <TimelineConnector sx={{ minHeight: '20px' }} />
        </TimelineSeparator>
        <TimelineContent></TimelineContent>
      </TimelineItem>

      {/* SKELETON ITEMS */}
      {Array.from({ length: 3 }).map((_, index) => {
        const side = index % 2 === 0 ? 'right' : 'left'

        return (
          <TimelineItem key={`skeleton-${index}`}>
            <TimelineSeparator className="LiveEventEvolutionTimelineSeparator">
              <Skeleton variant="rounded" width={100} height={24} sx={{ margin: '8px 0px 8px 0px', borderRadius: '25px' }} />
              {index < 2 && <TimelineConnector sx={{ minHeight: '20px' }} />}
            </TimelineSeparator>
            <TimelineContent>
              <Card className="LiveEventEvolutionTimelineCard">
                <CardContent
                  sx={{
                    display: 'flex',
                    flexDirection: side === 'left' ? 'row-reverse' : 'row',
                    minHeight: '35px',
                  }}
                >
                  <Box
                    sx={{
                      display: 'flex',
                      flexDirection: side === 'left' ? 'row' : 'row-reverse',
                      alignItems: 'center',
                      gap: 0.8,
                      width: '100%',
                    }}
                  >
                    <Skeleton variant="circular" width={24} height={24} />
                    <Skeleton variant="circular" width={24} height={24} />
                    <Skeleton variant="text" width={200} height={40} className="LiveEventEvolutionTimelineName" />
                  </Box>
                </CardContent>
                <Box sx={{ paddingBottom: 1, paddingLeft: 1, paddingRight: 1, paddingTop: 1 }}>
                  <Box sx={{ paddingLeft: 1, paddingRight: 1, paddingBottom: 1, paddingTop: 0.5 }}>
                    <Skeleton variant="text" width="100%" height={20} />
                    <Skeleton variant="text" width="80%" height={20} />
                  </Box>
                </Box>
              </Card>
            </TimelineContent>
          </TimelineItem>
        )
      })}
    </Timeline>
  )
}

export default LiveEventEvolutionTimelineSkeleton
